// wijmo
/* eslint-disable react-hooks/exhaustive-deps */
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
  // Table,
} from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faChevronDown,
  faChevronUp,
  faFileAlt,
  faPlusSquare,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"

import { useDispatch, useSelector } from "react-redux"
import dayjs from "dayjs"
import { generatePath, useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  TZimuinSyuroZikanListGetRes,
  TZimuinSyuroZikanListGetReq,
  TZimuinSyuroZikanPutReq,
} from "../../../service/driverpayroll/zimuinSyuroZikan/TZimuinSyuroZikan"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import { RootState } from "../../../globalStore/rootreducer"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import BusyoService from "../../../service/master/busyo/busyoService"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import Decimal from "decimal.js"
import { showInfoToast } from "../../../components/CustomToast"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { eレコード種別 } from "../../../constant/enum/frontend"
import { 画面ロック解除 } from "../../../globalStore/progressStore"
import { TApiResponse } from "../../../service/TApiResponse"
import { numberToMillisecond } from "../../../ts/util/decimalUtil"
import util from "../../../ts/util"
import { 給与管理メニューコード } from "../../../constant/menuCode"
import commonUtil from "../../../ts/util/commonUtil"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import ZimuinSyuroZikanService from "../../../service/driverpayroll/zimuinSyuroZikan/zimuinSyuroZikanService"
import saveAs from "file-saver"

// //#region [type]

// DefaultCombo
export type TItem = { name: string; value: any }

export type T事務員就労時間リスト = TZimuinSyuroZikanListGetRes & {
  行ID: symbol
}

// #endregion

/**
 * 事務員就労時間一覧
 * @returns
 */
const ZimuinSyuroZikanList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "ZimuinSyuroZikanList_GridId"

  //#region [method]

  interface ICalculatedFields {
    勤怠日数_出勤日数: number
    勤怠日数_休出日数: number
    勤怠日数_特休数: number
    勤怠日数_有休数: number

    就労時間_勤務時間: number
    就労時間_残業時間: number
    就労時間_深夜時間: number
    就労時間_休出時間: number
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TZimuinSyuroZikanListGetRes>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        // sort
        sort_部所コード: (i: TZimuinSyuroZikanListGetRes & ICalculatedFields) =>
          commonUtil.createSortString(
            i.所属部所コード,
            VALIDATE_CONSTANT.LENGTH.部所コード
          ),
        sort_社員コード: (i: TZimuinSyuroZikanListGetRes & ICalculatedFields) =>
          commonUtil.createSortString(
            i.社員コード,
            VALIDATE_CONSTANT.LENGTH.社員コード
          ),

        勤怠日数_出勤日数: (
          i: TZimuinSyuroZikanListGetRes & ICalculatedFields
        ) => {
          if (i.実績表示フラグ) {
            return i.事務員給与_出勤日数 ?? 0
          } else {
            return i.出勤日数 ?? 0
          }
        },
        勤怠日数_休出日数: (
          i: TZimuinSyuroZikanListGetRes & ICalculatedFields
        ) => {
          if (i.実績表示フラグ) {
            return i.事務員給与_休出日数 ?? 0
          } else {
            return i.休出日数 ?? 0
          }
        },
        勤怠日数_特休数: (
          i: TZimuinSyuroZikanListGetRes & ICalculatedFields
        ) => {
          if (i.実績表示フラグ) {
            return i.事務員給与_特休数 ?? 0
          } else {
            return i.特休数 ?? 0
          }
        },
        勤怠日数_有休数: (
          i: TZimuinSyuroZikanListGetRes & ICalculatedFields
        ) => {
          if (i.実績表示フラグ) {
            return i.事務員給与_有休数 ?? 0
          } else {
            return i.有休数 ?? 0
          }
        },
        /* 給与実績＞月間集計 の表示優先度で時間をミリ秒からNumberに変換する */
        就労時間_勤務時間: (
          i: TZimuinSyuroZikanListGetRes & ICalculatedFields
        ) => {
          const ミリ秒 = new Decimal(3600000)
          if (i.実績表示フラグ) {
            const 時間 = new Decimal(i.事務員給与_出勤時間 ?? 0)
            return 時間.div(ミリ秒).toNumber()
          } else {
            const 時間 = new Decimal(i.出勤時間 ?? 0)
            return 時間.div(ミリ秒).toNumber()
          }
        },
        就労時間_残業時間: (
          i: TZimuinSyuroZikanListGetRes & ICalculatedFields
        ) => {
          const ミリ秒 = new Decimal(3600000)
          if (i.実績表示フラグ) {
            const 時間 = new Decimal(i.事務員給与_残業時間 ?? 0)
            return 時間.div(ミリ秒).toNumber()
          } else {
            const 時間 = new Decimal(i.残業時間 ?? 0)
            return 時間.div(ミリ秒).toNumber()
          }
        },
        就労時間_深夜時間: (
          i: TZimuinSyuroZikanListGetRes & ICalculatedFields
        ) => {
          const ミリ秒 = new Decimal(3600000)
          if (i.実績表示フラグ) {
            const 時間 = new Decimal(i.事務員給与_深夜時間 ?? 0)
            return 時間.div(ミリ秒).toNumber()
          } else {
            const 時間 = new Decimal(i.深夜時間 ?? 0)
            return 時間.div(ミリ秒).toNumber()
          }
        },
        就労時間_休出時間: (
          i: TZimuinSyuroZikanListGetRes & ICalculatedFields
        ) => {
          const ミリ秒 = new Decimal(3600000)
          if (i.実績表示フラグ) {
            const 時間 = new Decimal(i.事務員給与_休出時間 ?? 0)
            return 時間.div(ミリ秒).toNumber()
          } else {
            const 時間 = new Decimal(i.休出時間 ?? 0)
            return 時間.div(ミリ秒).toNumber()
          }
        },
      },

      sortDescriptions: [
        new wjCore.SortDescription("sort_部所コード", true),
        new wjCore.SortDescription("sort_社員コード", true),
      ],

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TZimuinSyuroZikanListGetReq) => {
    setSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    setIsSearched(false)

    let currentSearchCondition: TZimuinSyuroZikanListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }

    setPreSearchCondition({ ...currentSearchCondition })

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new ZimuinSyuroZikanService().getList(
        currentSearchCondition
      )

      // 検索結果をstateにセット
      setGridData({
        data: createCollectionView(res.data, pageSize),
      })
      setIsSearched(true)
    } catch (error) {
      dispatch(setAlerts(error))
      setIsSearched(false)
    } finally {
      setSearching(false) // 検索中状態に遷移
      set実績更新済みフラグ(false)
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TZimuinSyuroZikanListGetReq = queryString.parse(
      location.search
    )
    set部所コード(query.部所コード ?? "")
    set年月(query.年月)

    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TZimuinSyuroZikanListGetReq => {
    return {
      部所コード: 部所コード ?? "",
      年月: 年月 ?? new Date().toISOString(),
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TZimuinSyuroZikanListGetReq
  ) => {
    const disp年月 = dayjs(searchCondition.年月).format("YYYY/MM")

    return {
      部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.部所コード
      )?.部所名,
      年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    var extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    // ヘッダー行に文言追加
    columnHeaders.columns.forEach((c, index) => {
      c.allowMerging = true
      c.align = "left"
      if (c.binding?.includes("社員") || c.binding?.includes("部所")) {
        columnHeaders.setCellData(0, index, "事務員")
      } else if (c.binding?.includes("勤怠日数_")) {
        columnHeaders.setCellData(0, index, "勤怠日数")
        c.align = "right"
      } else if (c.binding?.includes("就労時間_")) {
        columnHeaders.setCellData(0, index, "就労時間")
        c.align = "right"
      } else {
        columnHeaders.setCellData(0, index, c.header)
      }
    })

    // ヘッダのみAlignを調整する
    grid.itemFormatter = (panel, r, c, cell) => {
      if (
        (panel.cellType === wjGrid.CellType.ColumnHeader &&
          cell.innerHTML === "勤怠日数") ||
        cell.innerHTML === "就労時間"
      ) {
        cell.style.textAlign = "center"
      }
    }

    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const rowData: TZimuinSyuroZikanListGetRes = e.getRow().dataItem
      if (!rowData) return
    }
  }

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true)
  }

  //TODO:PUTのみAPIで処理
  const submit = async () => {
    try {
      let dataList: Array<TZimuinSyuroZikanPutReq> = []

      // 入力Gridをすべて新規データとしてセットする
      gridData.data.sourceCollection.forEach(
        (d: TZimuinSyuroZikanListGetRes & ICalculatedFields) => {
          // 整数フォーマットから、実績用にミリ秒変換して返却
          const t勤務時間 = numberToMillisecond(d.就労時間_勤務時間)
          const t残業時間 = numberToMillisecond(d.就労時間_残業時間)
          const t深夜時間 = numberToMillisecond(d.就労時間_深夜時間)
          const t休出時間 = numberToMillisecond(d.就労時間_休出時間)
          let data: TZimuinSyuroZikanPutReq = {
            給与実績ID: d.給与実績ID,
            レコード種別: eレコード種別.事務員就労時間一覧, // 事務員なので2固定
            給与支給年月: 年月!,
            社員ID: d.社員ID,

            事務員給与_出勤日数: d.勤怠日数_出勤日数,
            事務員給与_休出日数: d.勤怠日数_休出日数,
            事務員給与_特休数: d.勤怠日数_特休数,
            事務員給与_有休数: d.勤怠日数_有休数,
            事務員給与_出勤時間: t勤務時間,
            事務員給与_残業時間: t残業時間,
            事務員給与_深夜時間: t深夜時間,
            事務員給与_休出時間: t休出時間,
            事務員給与_更新日時: d.事務員給与_更新日時,
          }
          dataList.push(data)
        }
      )
      const service = new ZimuinSyuroZikanService()
      let res: TApiResponse<boolean>
      res = await service.putList(dataList)

      dispatch(setAlerts(res))
      if (res) {
        // if (true) {
        showInfoToast(`給与実績の更新が完了しました。`)
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()
        // リストア中フラグON
        setIsRestoreSearching(true)
        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
          set実績更新済みフラグ(true)
        })
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  const downloadCsv = async () => {
    const service = new ZimuinSyuroZikanService({ responseType: "blob" })

    try {
      // TODO:必要であれば部門も絞り込む
      const blob = await service.downloadCsv({
        年月: preSearchCondition?.年月!,
      })
      saveAs(blob, `事務員給与連携_${dayjs().format("YYYYMMDDHHmmss")}.csv`)
    } catch (err) {
      dispatch(setAlerts(err))
    } finally {
      setIsDownloadCsvConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [searching, setSearching] = useState(false) // 検索中
  const [isSearched, setIsSearched] = useState(false) // 検索完了

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  // ComboBox制御
  const [comboDataInitialized, setComboDataInitialized] =
    useState<boolean>(false)

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isDownloadCsvConfirmModalShow, setIsDownloadCsvConfirmModalShow] =
    useState(false)

  // モーダル側との検索動作判定用
  const [preSearchCondition, setPreSearchCondition] =
    useState<TZimuinSyuroZikanListGetReq>()
  //#endregion

  //#region [state]

  // ComboBoxState
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  // 設定
  const [部所コード, set部所コード] = useState<string | null>(null)
  const [年月, set年月] = useState<string | null>()

  // ボタン制御
  const [実績更新済みフラグ, set実績更新済みフラグ] = useState<boolean>(false)
  //#endregion

  //#region [effect]

  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
    })
  }, [])

  useEffect(() => {
    if (!部所IsLoadEnded) return

    setComboDataInitialized(true)
  }, [部所IsLoadEnded])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition)
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
      }
    }
  }, [gridInitialized, comboDataInitialized])

  useEffect(() => {
    document.title = `事務員就労時間一覧`
    set年月(eigyobi)
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">事務員就労時間一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card>
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <Row>
                              <Col>
                                <ul className="list-cmn d-flex">
                                  <li className="list-cmn list-padding">
                                    <ul className="list-cmn">
                                      <li>
                                        <div className="w-8rem">
                                          <MonthInput
                                            autoFocus={true}
                                            id="年月"
                                            value={年月}
                                            setValue={set年月}
                                            isRequired
                                            placeholder="年月"
                                          />
                                        </div>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </Col>
                            </Row>

                            <Row>
                              <Col>
                                <ComboBox.Busyo
                                  placeholder="部所"
                                  isAllSelect={true}
                                  itemsSource={部所ItemSource}
                                  selectedValue={部所コード}
                                  setSelectedValue={set部所コード}
                                  isLoadEnded={部所IsLoadEnded}
                                  setIsLoadEnded={set部所IsLoadEnded}
                                  ComboBox={部所ComboBox}
                                  setComboBox={
                                    set部所ComboBox
                                  }></ComboBox.Busyo>
                              </Col>
                            </Row>
                            <div className="search-condition-row">
                              <Button
                                type="submit"
                                disabled={searching}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  e.preventDefault()
                                  search()
                                }}>
                                <FontAwesomeIcon icon={faSearch} />
                                検索
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={searching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                isShowGridRowPickupButton={false}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                headerComponent={
                  <>
                    <Button
                      disabled={!isSearched}
                      type="submit"
                      variant="waiting"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        beforeSubmit()
                      }}>
                      <FontAwesomeIcon icon={faPlusSquare} />
                      給与実績更新
                    </Button>

                    <Button
                      disabled={!isSearched}
                      type="submit"
                      variant="waiting"
                      onClick={() => {
                        // 明細の実績情報を初期化していく
                        if (!flexGrid) return

                        // 表示ページ以外のItemsSourceも更新するため、GridDataを入れ替えする
                        let dataList: Array<TZimuinSyuroZikanListGetRes> = []
                        gridData.data.sourceCollection.forEach(
                          (
                            r: TZimuinSyuroZikanListGetRes & ICalculatedFields
                          ) => {
                            // 実績をクリアして値をセットしなおす。
                            // ※ CalculatedFieldsの自動計算が入りなおされる
                            let data: TZimuinSyuroZikanListGetRes = {
                              社員ID: r.社員ID,
                              所属部所コード: r.所属部所コード,
                              所属部所名: r.所属部所名,
                              社員コード: r.社員コード,
                              社員氏名: r.社員氏名,
                              年月: r.年月,
                              出勤日数: r.出勤日数,
                              休出日数: r.休出日数,
                              特休数: r.特休数,
                              有休数: r.有休数,
                              出勤時間: r.出勤時間,
                              残業時間: r.残業時間,
                              深夜時間: r.深夜時間,
                              休出時間: r.休出時間,

                              // 実績表示フラグを0（勤怠情報を表示）にする
                              // 念のためID以外の値もclearしておく。
                              実績表示フラグ: 0,
                              給与実績ID: r.給与実績ID,
                              事務員給与_出勤日数: undefined,
                              事務員給与_休出日数: undefined,
                              事務員給与_特休数: undefined,
                              事務員給与_有休数: undefined,
                              事務員給与_出勤時間: undefined,
                              事務員給与_残業時間: undefined,
                              事務員給与_深夜時間: undefined,
                              事務員給与_休出時間: undefined,
                              事務員給与_更新日時: r.事務員給与_更新日時,
                            }
                            dataList.push(data)
                          }
                        )
                        setGridData({
                          data: createCollectionView(dataList, pageSize),
                        })

                        flexGrid?.refresh()
                        showInfoToast("給与実績を初期化しました。")
                      }}>
                      実績初期化
                    </Button>

                    <Button
                      disabled={!isSearched || !実績更新済みフラグ}
                      className="btn-done"
                      type="submit"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        setIsDownloadCsvConfirmModalShow(true)
                      }}>
                      <FontAwesomeIcon icon={faFileAlt} />
                      給与連携CSV作成
                    </Button>
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  binding="所属部所名"
                  width={110}
                  sortMemberPath="sort_部所コード"
                  header="部所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員コード"
                  width={100}
                  sortMemberPath="sort_社員コード"
                  header="社員番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員氏名"
                  width={128}
                  header="氏名">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TZimuinSyuroZikanListGetRes>
                    ) => {
                      return (
                        <button
                          className="link-button text-primary"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )
                            const path = util.getMenuPath(
                              給与管理メニューコード.事務員就労時間修正
                            )

                            // 給与実績IDの有無で登録/更新を判断して遷移
                            if (context.item.給与実績ID) {
                              history.push(
                                generatePath(path[1], {
                                  year: dayjs(context.item.年月).format("YYYY"),
                                  month: dayjs(context.item.年月).format("MM"),
                                  syainid: context.item.社員ID.toString(),
                                  id: context.item.給与実績ID.toString(),
                                })
                              )
                            } else {
                              history.push(
                                generatePath(path[0], {
                                  year: dayjs(context.item.年月).format("YYYY"),
                                  month: dayjs(context.item.年月).format("MM"),
                                  syainid: context.item.社員ID.toString(),
                                })
                              )
                            }
                          }}>
                          {context.item.社員氏名}
                        </button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn
                  binding="勤怠日数_出勤日数"
                  format="N1"
                  width={80}
                  header="出勤"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="勤怠日数_休出日数"
                  format="N1"
                  width={80}
                  header="休出"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="勤怠日数_特休数"
                  format="N1"
                  width={80}
                  header="特休"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="勤怠日数_有休数"
                  format="N1"
                  width={80}
                  header="有休"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="就労時間_勤務時間"
                  format="G"
                  width={90}
                  header="勤務"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="就労時間_残業時間"
                  format="G"
                  width={90}
                  header="残業"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="就労時間_深夜時間"
                  format="G"
                  width={90}
                  header="深夜"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="就労時間_休出時間"
                  format="G"
                  width={90}
                  header="休出"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* 給与計算実行 */}
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された計算内容で登録しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isDownloadCsvConfirmModalShow}
        hideHandler={setIsDownloadCsvConfirmModalShow}
        submitHandler={downloadCsv}>
        給与連携用CSVを出力しますか？<br></br>※
        給与実績更新の後に出力してください。
      </ConfirmModal>
    </Container>
  )
}

export default ZimuinSyuroZikanList
